/** MUI */
import {
  Box,
  Container,
  Grid2 as Grid,
} from "@mui/material";

/** Components */
import classes from "./terms.module.css";

const AdditionalTerms = () => {
  return (
    <Box className={classes.featuresCustomer}>
      <Container maxWidth="xl" disableGutters className={classes.containerFeat}>
        <Grid container spacing={{ xs: 2, xxl: 6 }}>
          <Grid size={{ xs: 12 }}>
            <Box className={classes.subcontent} textAlign="justify">
              <Box className={classes.subcontent2}>
                <Box ml={3}>
                  <ol>
                    <li class="ListParagraph">
                      <strong>Partner Program</strong>.{" "}
                      <span>
                        A Customer that actively manages a high volume of
                        Accounts with active Plans may qualify as a Noddok
                        Partner (“<strong>Partner</strong>” or “
                        <strong>Partners”</strong>).
                      </span>
                      <span>
                        Partners are part of Noddok’s Partners Program (“
                        <strong>Partners Program</strong>”).
                      </span>
                    </li>
                  </ol>
                  <ol start="2">
                    <li class="ListParagraph">
                      <strong>Application</strong>.{" "}
                      <span>
                        To qualify as a Partner, a prospect must, through an
                        Owner, complete a sign-up form available on Noddok’s
                        app. Upon submission of the form, Noddok will review the
                        application and may accept or reject the Partner's
                        participation in the program.{" "}
                      </span>
                    </li>
                  </ol>
                  <ol start="3">
                    <li class="ListParagraph">
                      <strong>No Implied Admission</strong>.{" "}
                      <span>
                        Notwithstanding a prospect’s ability to meet the
                        criteria set forth to become a Partner under the
                        Partners Program, a Customer will not be automatically
                        deemed a Partner until Noddok accepts an application
                        under Section 3 of these additional Terms.
                      </span>
                    </li>
                  </ol>
                  <ol start="4">
                    <li class="ListParagraph">
                      <strong>Revisions</strong>.{" "}
                      <span>
                        The Company may revise the Partners Program and the
                        benefits thereunder at any time.
                      </span>
                    </li>
                  </ol>
                  <ol start="5">
                    <li class="ListParagraph">
                      <strong>Termination</strong>.{" "}
                      <span>
                        These Terms will remain in effect between Partner and
                        the Company until its termination. Either party may
                        terminate the partnership for any reason by providing
                        the terminating party one month’s written notice. The
                        partnership will be terminated upon any breach by
                        Partner of Noddok’s Terms of Use, including these
                        additional Terms for Partners. Any outstanding discounts
                        will be ineffective after the notice of termination
                        period, and Partner will no longer be able to
                        participate in the program. However, the termination of
                        Partner’s benefits may not entail or produce the
                        termination of the Terms and Conditions of Service, so
                        long as Partner remains a Customer under Section I(1)
                        thereto.
                      </span>
                    </li>
                  </ol>
                </Box>
              </Box>
            </Box>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
};

export default AdditionalTerms;